import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box';
import { Text } from '../Text';
export const LabelledText = ({ label, children, labelMargin = 4, ...marginProps }) => (React.createElement(Container, { ...marginProps, "$labelMargin": labelMargin + 'px' },
    React.createElement(Text, { tag: "label", color: "sesame", typo: "label" }, label),
    children));
const Container = styled(Box) `
  display: flex;
  flex-direction: column;

  label {
    margin-bottom: ${({ $labelMargin }) => $labelMargin};
  }
`;
//# sourceMappingURL=LabelledText.js.map